import React, { useState, useEffect, useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/**
 * OptionsMenu - Componente de menú reutilizable con ícono de tres puntos
 */
function OptionsMenu({
    children,
    id = 'options-menu',
    ariaLabel = 'more',
    iconButtonProps = {},
    menuProps = {}
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [childModalOpen, setChildModalOpen] = useState(false);
    const open = Boolean(anchorEl);
    const observerRef = useRef(null);

    // Observamos el portal del átomo Modal (el div.modal que se inyecta en body)
    useEffect(() => {
        const checkForModal = () => {
            const modalInDom = document.querySelector('.modal');
            setChildModalOpen(!!modalInDom);
        };

        observerRef.current = new MutationObserver(checkForModal);
        observerRef.current.observe(document.body, { childList: true, subtree: false });

        return () => observerRef.current?.disconnect();
    }, []);

    const handleClickMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = (event, reason) => {
        // No cerrar si hay un modal hijo activo
        if (childModalOpen) return;
        setAnchorEl(null);
    };

    const handleItemClick = (childOnClick) => (event) => {
        event.stopPropagation();
        if (childOnClick) childOnClick(event);
    };

    return (
        <>
            <IconButton
                aria-label={ariaLabel}
                id={`${id}-button`}
                aria-controls={open ? id : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClickMenu}
                {...iconButtonProps}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id={id}
                MenuListProps={{
                    'aria-labelledby': `${id}-button`,
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                {...menuProps}
            >
                {React.Children.map(children, child => {
                    if (React.isValidElement(child)) {
                        return (
                            <MenuItem sx={{ p: 0, minHeight: 'auto' }}>
                                {React.cloneElement(child, {
                                    onClick: handleItemClick(child.props.onClick)
                                })}
                            </MenuItem>
                        );
                    }
                    return child;
                })}
            </Menu>
        </>
    );
}

export default OptionsMenu;

